export function throwError(e, defaultErrorMessage = 'Unknown error.') {
  if (
    typeof e === 'object' &&
    e.response &&
    e.response.data
  ) {
    e = e.response.data; // Extract true error object from HTTP errors.
  }
  if (e instanceof Error) throw e;
  else if (typeof e === 'object') throw new Error(e.message || e.msg || e.text || e.statusText || defaultErrorMessage)
  else if (['string', 'number', 'boolean'].includes(typeof e)) throw new Error(e);
  else if (defaultErrorMessage) throw new Error(e);
  else console.error('Cannot use throwError() function due to an invalid argument. The first argument for this function must be one of the following types: [Error, Object, String, Number, Boolean]. The second argument should be the default error message that is used in the event that a valid error message cannot be parsed from the first argument.');
}